/* tslint:disable */
/* eslint-disable */

/**
 * Lifecycle state of an export. FSM: `pending` → `running` →
 * (`ready` | `failed`) → `expired`. `expired` is only reachable from
 * `ready`, via the daily sweeper.
 */
export enum ExportStatus {
  Pending = 'pending',
  Running = 'running',
  Ready = 'ready',
  Failed = 'failed',
  Expired = 'expired'
}
